/* Product page, below the buy box (product-details, product-faq).
   - Questions: each button carries aria-expanded and controls its region.
   - All specifications (phones): shows the rows past the sixth.
   One delegated listener for the whole document, so sections reloaded in the theme editor
   need nothing re-bound. */
(function () {
  "use strict";
  if (window.__vitalisPdpBody) return;
  window.__vitalisPdpBody = true;
  var d = document;

  d.addEventListener("click", function (e) {
    if (!(e.target instanceof Element)) return;
    var acc = e.target.closest("[data-pdp-acc]");
    if (acc) {
      var region = d.getElementById(acc.getAttribute("aria-controls"));
      var open = acc.getAttribute("aria-expanded") !== "true";
      acc.setAttribute("aria-expanded", String(open));
      if (region) region.hidden = !open;
      return;
    }
    var more = e.target.closest("[data-pdp-specs]");
    if (more) {
      var list = d.getElementById(more.getAttribute("aria-controls"));
      var all = more.getAttribute("aria-expanded") !== "true";
      more.setAttribute("aria-expanded", String(all));
      if (list) list.classList.toggle("is-all", all);
    }
  });

  /* Theme editor: selecting a question block opens it. */
  d.addEventListener("shopify:block:select", function (e) {
    var btn = e.target && e.target.querySelector && e.target.querySelector("[data-pdp-acc]");
    if (btn && btn.getAttribute("aria-expanded") !== "true") btn.click();
  });
})();
